import type { RouteRecordRaw } from 'vue-router';

// A2.5 donors — admin only, org-scoped (no /auctions/:id prefix).
export const routes: RouteRecordRaw[] = [
  {
    path: '/donors',
    name: 'donors',
    component: () => import('./pages/DonorsPage.vue'),
    meta: { requiresAdminAuth: true, requiredRole: 'admin', skipAuctionLoad: true },
  },
];
